import * as runtypes from 'runtypes';

export const Locale = runtypes.Union(runtypes.Literal('ja'), runtypes.Literal('en'));

export type Locale = runtypes.Static<typeof Locale>;
